// extracted by mini-css-extract-plugin
module.exports = {"notion-icon":"style_notion-icon__u_kj5","website-icon":"style_website-icon__TliOU","workspace-item":"style_workspace-item__prJ27"};